import axios from 'axios';
import qs from 'querystring';

/*
this is just for the token call, it doesn't use the api route, and it needs
to have a content type of form url encoded and not json like normal api stuff
*/
const config = {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	}
}

const RESOURCE_NAME = '/api/account';

export default {
	login(data) {
		return axios.post('/Token', qs.stringify(data), config);
	},

	logout() {
		return axios.post(`${RESOURCE_NAME}/logout`);
	},

	getAll() {
		return axios.get(`${RESOURCE_NAME}/users`);
	},

	getRoles() {
		return axios.get(`${RESOURCE_NAME}/roles`);
	},

	get(id) {
		return axios.get(`${RESOURCE_NAME}/user/${id}`);
	},

	getUserInfo() {
		return axios.get(`${RESOURCE_NAME}/userinfo`);
	},

	forgottenPassword(data) {
		return axios.post(`${RESOURCE_NAME}/forgottenpassword`, data);
	},

	resetPassword(data) {
		return axios.post(`${RESOURCE_NAME}/resetpassword`, data);
	},

	

	getPing() {
		return axios.get(`${RESOURCE_NAME}/ping`);
	},

	update(id, data) {
		return axios.put(`${RESOURCE_NAME}/user/${id}`, data);
	},

	delete(id) {
		return axios.delete(`${RESOURCE_NAME}/user/${id}`);
	},

	// register new
	register(data) {
		return axios.post(`${RESOURCE_NAME}/register`, data);
	}
};


// WEBPACK FOOTER //
// ./src/api-services/account.service.js